import React, { useEffect, useState } from "react";
import "./bringWidget.css";
import SaveWidgetButton from "../../button/saveWidgetButton/saveWidgetButton";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import BringWidget from "./bringWidget";
import RemoveWidgetButton from "../../button/removeWidgetButton/removeWidgetButton";
import CloseWidgetButton from "../../button/closeWidgetButton/closeWidgetButton";

function EditBringWidget() {
  const currentEvent = useSelector((state) => state.eventReducer.currentEvent);
  const editWidgetContent = useSelector((state) => state.dashboardReducer.editWidgetContent);
  const [widgetId, setWidgetId] = useState(uuidv4());
  const [size, setSize] = useState("large");

  useEffect(() => {
    if (editWidgetContent.type === "bring") {
      console.log(editWidgetContent);
      setWidgetId(editWidgetContent.id);
      setSize(editWidgetContent.size);
    }
  }, [editWidgetContent]);

  return (
    <div
      className="editWidgetModal"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="editWidgetContent">
        <div className="editWidgetMainContent">
          <div className="editWidgetTitleRow">
            <div className="editWidgetTitle">Contributions</div>
            <CloseWidgetButton />
          </div>
          <div className="editWidgetDesc">Let guests know what others are bringing.</div>
          <div className="sizeSelector">
            <div className="sizeSampleLarge">
              <BringWidget
                live={false}
                data={{
                  id: widgetId,
                  type: "bring",
                  event_id: currentEvent.event_id,
                  size: size,
                  index: editWidgetContent?.index ?? 0,
                }}
              />
            </div>
          </div>
        </div>
        <div className="saveAction">
          {editWidgetContent?.id ? (
            <RemoveWidgetButton widget={{ dashboard_id: widgetId, event_id: currentEvent.event_id }} />
          ) : null}
          <SaveWidgetButton
            saveContent={{
              id: widgetId,
              type: "bring",
              title: "",
              event_id: currentEvent.event_id,
              answers: [],
              size: size,
              index: editWidgetContent?.index ?? 0,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default EditBringWidget;
